import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Row, Form } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
// import AddUserDrawer from "./AddUserDrawer";
import StatusAddUpdateTable from './StatusTable';
import { employeeProfileDetail } from 'services/redux/profile/profile.action';
import StatusAddUpdateDrawer from './StatusDrawer';
import { ProjectService } from '../../../../services/redux/Reference/Project/api';

const Status = () => {
	const dispatch = useDispatch();
	const [form] = Form.useForm();
	const onReset = () => {
		form.resetFields();
	};

	const [addUpdateStatusDrawerVisibility, setaddUpdateStatusDrawerVisibility] = useState(false);
	const [isUpdateStatus, setIsUpdateStatus] = useState(false);

	const showAddUpdateStatusDrawer = (e, record) => {
		setaddUpdateStatusDrawerVisibility(false);
		if (record) {
			setIsUpdateStatus(record);
		} else {
			setIsUpdateStatus(false);
		}
		setaddUpdateStatusDrawerVisibility(true);
	};

	const onAddUpdateStatusClose = () => {
		setIsUpdateStatus('');
		setaddUpdateStatusDrawerVisibility(false);
	};

	return (
		<div className="layout">
			<div className="organizer events">
				<div className="all-header-wrapper">
					<div className="meeting__flex">
						<h3 className="header__all">Status List</h3>
						<div className="organizerHoliday__middle--wrap">
							<Button
								className="btn-primary"
								onClick={() => {
									showAddUpdateStatusDrawer();
								}}
							>
								<PlusOutlined /> New Status
							</Button>
						</div>
					</div>
				</div>
				<StatusAddUpdateTable showAddUpdateStatusDrawer={showAddUpdateStatusDrawer} />
				<StatusAddUpdateDrawer drawerVisibility={addUpdateStatusDrawerVisibility} onAddUpdateStatusClose={onAddUpdateStatusClose} isUpdateStatus={isUpdateStatus} />
			</div>
		</div>
	);
};

export default Status;
